import React from "react";

const Loading = () => {
    return (
        <div className="loading__container">
            <div className="loading__counter">Loading...</div>
            <div className="loading__circle"></div>
        </div>
    );
};
export default Loading;
